<template>
  <div class="order-history-page">
    <div class="bd-container">
      <div class="order-charts">
        <div class="hd">
          <div class="search">
            <date-picker v-model="date1" valueType="format" appendToBody></date-picker>
            <span class="txt">至</span>
            <date-picker v-model="date2" valueType="format" appendToBody></date-picker>
            <select class="sl3" v-model="taskType" @change="typeSelect">
              <option v-for="item in taskTypes" :value="item.value" v-if="item.value < 4" v-text="item.label"></option>
              <option value="4">其他任务</option>
            </select>
            <div class="ckbox"><input type="checkbox" v-model="ShowEmptyTray">空托盘</div>
            <span class="sbtn" @click="getHistoryData()">查询</span>
          </div>
        </div>
        <div class="bd">
          <div class="chart-item">
            <img :src="'/static/theme-green/images/order/rwlx.png'" class="tit">
            <div class="chart-box cb1">
              <v-chart :options="options_rwlx" />
            </div>
            <div class="chart-bottom">
              总任务量：<span v-text="rwlxTotal"></span>
            </div>
          </div>
          <div class="chart-item">
            <img :src="'/static/theme-green/images/order/ckklfb.png'" class="tit">
            <div class="chart-box">
              <v-chart :options="options_ckklfb" />
            </div>
          </div>
          <div class="chart-item">
            <img :src="'/static/theme-green/images/order/crkzb.png'" class="tit">
            <div class="chart-box">
              <v-chart :options="options_crkzb" />
            </div>
          </div>

          <!-- 入库任务 -->
          <div class="chart-item">
            <img :src="'/static/theme-green/images/order/mddfb.png'" class="tit">
            <div class="chart-box">
              <div class="tab">
                <span v-for="item in taskTypes" v-if="item.value==1||item.value==2" :class="[{'active': DesCurTaskType==item.value}]" @click="DesTabSwitch(item)" v-text="item.label"></span>
              </div>
              <div class="ls" v-for="(items, index) in mddfbList" v-if="items.taskType==DesCurTaskType">
                <div class="item" v-for="item in items.items">
                  <div class="bx">
                    <v-chart :options="item.options" />
                  </div>
                  <div class="txt" v-text="item.label"></div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="task-detail">
        <div class="hd">
          <img :src="'/static/theme-green/images/order/rwxqxz.png'" class="tit">
          <div class="search">
            <input type="text" v-model="taskNumber" v-on:input="watchTaskNumber" placeholder="请输入任务编号">
            <span class="sbtn" @click="getTaskTab()">查询</span>
          </div>
        </div>
        <div class="bd">
          <div class="tab">
            <span v-for="(item, key) in taskTab" :class="[{'current': key==taskTabKey}]" v-text="item.count?key+'('+item.count+')':key" @click="taskTabSwitch(key)"></span>
          </div>
          <div class="tab-ch">
            <template v-for="(item, key) in taskTab" v-if="key==taskTabKey">
              <div v-for="(tbitem, index) in item.tabs"><span v-text="tbitem.label+'('+tbitem.count+')'" :class="[{'current': index==taskTabChildrenIndex}]" @click="tabChildSwitch(index, tbitem)"></span></div>
            </template>
          </div>
          <div class="list-box" v-show="taskListShowed">
            <table>
              <tbody>
                <template v-for="(item, index) in taskList" v-if="item.length>0">
                  <tr>
                    <td v-for="(d,k) in item" @click="showDetail(d)" :class="[{'error': d.DelayedTime>0||d.Unnormal}]"><span v-text="d.TaskNo"></span></td>
                    <td v-for="emitm in (4-item.length)"></td>
                  </tr>
                </template>
              </tbody>
            </table>

            <div class="page-container">
              <v-pagination :total="totalCount" :current-page='pageIndex' :display="pageSize" @pagechange="pageChange"></v-pagination>
            </div>
          </div>

          <div class="detail-box" v-show="!taskListShowed">
            <div class="return">
              <img :src="'/static/theme-green/images/order/btn-return.png'" @click="taskListShowed=true" style="cursor: pointer;height:40px;">
            </div>
            <div class="rw-detail">
              <div class="block">任务详情</div>
              <div class="block">
                <div class="item">
                  <span class="label">所属订单：</span>
                  <span class="value" v-text="taskItem.ParentOrderNo"></span>
                </div>
                <div class="item">
                  <span class="label" style="heitt:360px">任务类型：</span>
                  <span class="value" v-for="tpitem in taskTypes" v-if="taskItem.TaskType&&tpitem.value==taskItem.TaskType" v-text="tpitem.label"></span>
                </div>
                <div class="item">
                  <span class="label">起始站台：</span>
                  <span class="value" v-text="taskItem.StartStation"></span>
                </div>
                <div class="item">
                  <span class="label">依赖任务：</span>
                  <span class="value" v-text="taskItem.DependOnTask"></span>
                </div>
              </div>
              <div class="block">
                <div class="item">
                  <span class="label">任务编号：</span>
                  <span class="value" v-text="taskItem.TaskNo"></span>
                </div>
                <div class="item">
                  <span class="label">任务优先级：</span>
                  <span class="value" v-text="taskItem.Priority"></span>
                </div>
                <div class="item">
                  <span class="label">目标站台：</span>
                  <span class="value" v-text="taskItem.EndStation"></span>
                </div>
                <div class="item">
                  <span class="label">波次号：</span>
                  <span class="value" v-text="taskItem.WaveNo"></span>
                </div>
              </div>
            </div>
            <div class="yc-node" v-if="taskItem.DelayedTime>0||taskItem.Unnormal">
              <div class="tit">异常节点</div>
              <div class="list-node">
                <div class="nd-block" v-for="item in taskUnusualNode">
                  <div class="nd-block-content">
                    <div class="nd-item">
                      <span class="label">站台区间：</span>
                      <span class="value" v-text="item.StationInfo"></span>
                    </div>
                    <div class="nd-item">
                      <span class="label">延时时间：</span>
                      <span class="value" v-text="Math.round(item.DelayedTime*10)/10+'min'"></span>
                    </div>
                    <div class="nd-item">
                      <span class="label">延时分析：</span>
                      <span class="value" v-text="item.Message"></span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="node-page" v-if="taskUnusualNodeCount > 0">
                <span :class="[{'current': item==taskUnusualNodeIndex}]" v-for="item in Math.ceil(taskUnusualNodeCount/2)" @click="showNode(item)" v-text="item"></span>
              </div>
            </div>
            <div class="lc-process" v-else>
              <div class="block bl1">
                <span class="tit">任务历程</span>
              </div>
              <div class="block bl2">
                <div class="bar">
                  <img :src="'/static/theme-green/images/order/process-bar.png'" width="100%" alt="">
                </div>
                <div class="block-content">
                  <div class="item">
                    <div>实际用时:</div>
                    <div v-text="(taskItem.TaskCreateProcess?Math.round(taskItem.TaskCreateProcess.ActualTime*100)/100:0)+'min'"></div>
                  </div>
                  <div class="item">
                    <div>实际用时:</div>
                    <div v-text="(taskItem.DeleveryEquiment?Math.round(taskItem.DeleveryEquiment.ActualTime*100)/100:0)+'min'"></div>
                  </div>
                  <div class="item">
                    <div>实际用时:</div>
                    <div v-text="(taskItem.EquimentExcuteFinish?Math.round(taskItem.EquimentExcuteFinish.ActualTime*100)/100:0)+'min'"></div>
                  </div>
                  <div class="item">
                    <div>实际用时:</div>
                    <div v-text="(taskItem.TaskFinishProcess?Math.round(taskItem.TaskFinishProcess.ActualTime*100)/100:0)+'min'"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>    
  </div>
</template>

<script type="es6">
import echarts from 'echarts/lib/echarts'
import pagination from '@/components/widgets/Pagination'
import DatePicker from 'vue2-datepicker'
//import { setInterval } from 'timers';
export default{
  components: {
    'v-pagination': pagination,
    DatePicker,
  },
  props: ['theme'],
  data() {
    let taskTypes = [  //大于3的都为其他任务
      {
        value: 0,
        label: '全部类型'
      },
      {
        value: 1,
        label: '出库任务'
      },
      {
        value: 2,
        label: '入库任务'
      },
      {
        value: 3,
        label: '盘点任务'
      },
      {
        value: 4,
        label: '盘点出库'
      },
      {
        value: 5,
        label: '盘点入库'
      },
      {
        value: 6,
        label: '质检入库'
      },
      {
        value: 7,
        label: '质检出库'
      },
      {
        value: 8,
        label: '紧急补料'
      },
      {
        value: 9,
        label: '补货'
      },
      {
        value: 10,
        label: '拣选'
      },
      {
        value: 11,
        label: '空托盘组出库'
      },
      {
        value: 12,
        label: '空托盘组入库'
      },
      {
        value: 13,
        label: '越库'
      },
      {
        value: 14,
        label: '越库RF任务'
      },
      {
        value: 15,
        label: '退库'
      },
    ];
    let taskTab = {"全部任务": {cateid: 1}, "延时任务": {cateid: 2}, "正常任务": {cateid: 3}};
    let todayTime = (new Date(new Date().setHours(0, 0, 0, 0)).getTime()) / 1000;  //今天0点时间戳秒
    return {
      taskTypes: taskTypes,
      taskType: 0,
      historyData: {},
      rwlxList: [],
      options_rwlx: {},
      rwlxTotal: 0,
      ckklfbList: [],
      options_ckklfb: {},
      crkzbList: [],
      options_crkzb: {},
      mddfbList: [],
      options_mddfb: [],
      DesCurTaskType: 1,
      //DesTabData: [],
      taskTabLabel: {},
      taskTabChildrenIndex: 0,
      taskList: [],
      taskNumber: '',
      taskTab: taskTab,
      taskTabKey: Object.keys(taskTab)[0],
      totalCount: 0,
      pageIndex: 1,
      pageSize: 36,
      taskListShowed: true,
      taskItem: {},
      taskUnusualNode: [],
      taskUnusualNodeIndex: 1,
      taskUnusualNodeCount: 0,
      rangeDate: '',
      date1: '2020-04-29',//this.$formatDateTime(todayTime, 'yyyy-MM-dd'),
      date2: '2020-04-30',//this.$formatDateTime(todayTime + 3600*24, 'yyyy-MM-dd'),
      ShowEmptyTray: true,
    }
  },  
  mounted() {
    //定义全局方法
    window.gbfc_resetData = this.resetData;
    //初始化
    this.$initPage(this);    
  },
  methods: {
    resetData() {
      //获取历史数据
      this.getHistoryData();
      //任务详情
      this.getTaskTab();
      //目的地分布
      this.getMddfbList();
    },
    taskTabSwitch(key) {
      this.taskTabKey = key;
      this.tabChildSwitch(0, this.taskTab[key]);
      console.log('--taskTabSwitch--', this.taskTabKey, this.taskTab)
    },
    tabChildSwitch(index, item) {
      console.log('--item--', item);
      this.taskTabChildrenIndex = index;
      this.taskListShowed = true;
      this.getTaskTab();
    },
    pageChange(pageIndex) {
      console.log('pageIndex', pageIndex);
      this.pageIndex = pageIndex;
      this.getTaskTab();
    },
    DesTabSwitch(item) {
      this.DesCurTaskType = item.value;
      this.getMddfbList();
    },

    typeSelect() {
      console.log('typeSelect', this.taskType)
    },
    getHistoryData() {
      let self = this;
      this.$handleRequest(window.ApiHost1+'/api/DataStatistical/HistTasksBasic_Info', {
       
       "ShowEmptyTray": this.ShowEmptyTray,
        "TaskType": "",
        "StartDate": this.date1,
        "EndDate": this.date2,
        "WareHouseCode": window.PYKWareHouseCode

      }, 'post', function(res) {  //success


        self.historyData = res.retData;
        //任务类型
        self.getRwlxList();
        //出库库龄分布
        self.getCkklfbList();
        //出入库占比
        self.getCrkzbList();
        //目的地分布
        self.getMddfbList();
      }, function(res) {
        //fail
      });
    },


    getRwlxList(){
      let self = this;
      let total = 0;
      this.rwlxList = this.historyData.HistTask_TypRto.Rows;

      console.log( this.rwlxList)
      this.rwlxList.forEach( function(l, li) {
        l.label = '';
        l.Ratio = Math.floor(parseFloat(l.Ratio)*100)/100;
        total += l.Count;
        self.taskTypes.forEach( function(t, ti) {
          if(l.TaskType == t.value) {
            l.label = t.label;
          }
        });
      });
      this.rwlxTotal = total;
      this.setOptionsRwlx();
    },
    setOptionsRwlx() {
      let colors = this.$charts.colors.style_1;
      let chartsConf = this.$charts[window.CurrentTheme];
      let sdata = [];
      this.rwlxList.forEach( function(d, di) {
        let color1 = colors[di][0];
        let color2 = colors[di][1];
        let tmp = {
          value: d.Count,
          name: d.label+'('+d.Count+')',
          label: {
            normal: {
                rich: {
                  hr: {
                    borderColor: color1
                  },
                  per: {
                    color: color1
                  }
                }
            }
          },
          itemStyle:{
            normal:{
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {offset: 0, color: "#99adff"}, {offset: 1, color: "#394bc1"}
              ])
            }
          }
        };
        sdata.push(tmp);
      });

      this.options_rwlx = {
        series: [
          {
            type:'pie',
            radius: ['38%', '55%'],
            center: ['50%', '50%'],
            startAngle:270, //起始角度
            avoidLabelOverlap: true,
            labelLine: {
              //length: 30,
              length2: 30
            },
            label: {
              normal: {
                  formatter: '{per|{d}%} \n{hr|}\n {b|{b}}',
                  backgroundColor: '#D2D7ED', //'chartsConf.series.backgroundColor,'
                  padding: 12,
                  rich: {
                    /*hr: {
                      //borderColor: '#fff',
                      width: '100%',
                      borderWidth: 0.5,
                      height: 0,
                    },*/
                    b: {
                      fontSize: 20,
                      color: "#7a84c5",
                      //padding: [0, 0, 0, 0]
                    },
                    per: {
                      align: 'center',
                      fontSize: 20,
                      color: "#384598",
                      //padding: [0, 0, 0, 0]
                    }
                  }
              }
            },
            data: sdata
          }
        ]
      };
    },
    getCkklfbList() {
      let self = this;
      this.ckklfbList = this.historyData.HistOutTask_Age.Rows;
      this.setOptionsCkklfb();
    },
    setOptionsCkklfb() {
      let self = this;
      let colors = this.$charts.colors.style_3;
      let chartsConf = this.$charts[window.CurrentTheme];
      let legendData = [];
      let xdata = [];
      let sdata = [];
      let ldata = [];

      this.ckklfbList.forEach( function(d, di) {
        ldata.push(d.Count);
        xdata.push(d.Name);
      });
      let tmp = {
        //name: '',
        type:'bar',
        barWidth: 20,//柱图宽度
        barGap: '10%',
        color: colors[0],
        data: ldata
      }
      sdata.push(tmp);

      this.options_ckklfb = {
        tooltip: {
          trigger: 'axis',
          axisPointer : {
            type : 'shadow'
          }
        },
        /*legend: {
          //right: 100,
          textStyle: {
            color: "#fff",
            fontSize: 22
          },
          data: legendData
        },*/
        xAxis : [
          {
            type : 'category',
            axisLabel: {
              color: '#000',
              fontSize: 16,
              margin: 16,
            },
            //设置轴线的属性
            axisLine:{
              lineStyle: {
                color: '#e6e6e6',
                width: 1, //这里是为了突出显示加上的
              }
            },
            data : xdata
          }
        ],
        yAxis : [
          {
            name: '数量',
            type : 'value',
            nameGap: 30,
            nameTextStyle: {
              color: '#000',
              fontSize: 16
            },
            axisLabel: {
              color: '#000',
              fontSize: 16,
            },
            //设置轴线的属性
            axisLine:{
              lineStyle: {
                color: '#e6e6e6',
                width: 1, //这里是为了突出显示加上的
              }
            },
            splitLine: {
              show: true,
              lineStyle:{
                color: '#e6e6e6',
                width: 1,
                type: 'solid'
              }
            }
          }
        ],
        series : sdata
      };
    },
    getCrkzbList() {
      let self = this;
      this.crkzbList = this.historyData.ShelfFlowHistTask.Rows;
      this.setOptionsCrkzb();
    },
    setOptionsCrkzb() {
      let self = this;
      let colors = this.$charts.colors.style_4;
      let chartsConf = this.$charts[window.CurrentTheme];
      let legendData = ['出库占比', '入库占比'];
      let xdata = [];
      let sdata = [];

      legendData.forEach( function(l, li) {
        let tmpdata = [];
        self.crkzbList.forEach( function(d, di) {
          if(li == 0) {
            tmpdata.push(Math.floor(d['OutRatio']*100)/100);
          } else if(li == 1) {
            tmpdata.push(Math.floor(d['InRatio']*100)/100);
          }
          if(xdata.indexOf(d.ShelfNo) == -1) {
            xdata.push(d.ShelfNo);
          }
        });
        let tmp = {
          name: l,
          type:'line',
          color: colors[li],
          symbol: 'circle',
          symbolSize: 15,
          data: tmpdata
        };
        sdata.push(tmp);
      });

      this.options_crkzb = {
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          right: 100,
          textStyle: {
            color: '#000',
            fontSize: 16
          },
          data: legendData
        },
        xAxis : [
          {
            type : 'category',
            name: '货架',
            nameTextStyle: {
              color: '#000',
              fontSize: 16
            },
            axisLabel: {
              color: '#000',
              fontSize: 16,
              margin: 16,
            },
            //设置轴线的属性
            axisLine:{
              lineStyle: {
                color: "#e6e6e6",
                width: 1, //这里是为了突出显示加上的
              }
            },
            data : xdata
          }
        ],
        yAxis : [
          {
            type : 'value',
            axisLabel: {
              color: '#000',
              fontSize: 16,
              formatter: '{value}%'
            },
            //设置轴线的属性
            axisLine:{
              lineStyle: {
                color: "#e6e6e6",
                width: 1, //这里是为了突出显示加上的
              }
            },
            splitLine: {
              show: true,
              lineStyle:{
                color: "#e6e6e6",
                width: 1,
                type: 'solid'
              }
            },
          }
        ],
        series: sdata
      };
    },
    getMddfbList() {
      let self = this;
      this.mddfbList = [
        {
          taskType: 1,
          items: [
            {
              label: '制丝A线',
              number: '1047',
              options: {}
            },
            {
              label: '制丝B线',
              number: '1119',
              options: {}
            },
            {
              label: '制丝C线',
              number: '1096',
              options: {}
            },
            {
              label: '其他',
              number: '-1',
              options: {}
            },
          ]
        },
        {
          taskType: 2,
          items: [
            {
              label: '巷道1',
              number: '001',
              options: {}
            },
            {
              label: '巷道2',
              number: '002',
              options: {}
            },
            {
              label: '巷道3',
              number: '003',
              options: {}
            },
            {
              label: '巷道4',
              number: '004',
              options: {}
            },
          ]
        }
      ];

      this.setOptionsMddfb();
    },
    setOptionsMddfb() {
      let self = this;
      let colors = this.$charts.colors.style_5;
      let chartsConf = this.$charts[window.CurrentTheme];

      let dataStyle = {
          normal: {
            label: {show:false},
            labelLine: {show:false}
          }
      };
      let placeHolderStyle = {
          normal : {
              color: 'rgba(0,0,0,0)',
              label: {show:false},
              labelLine: {show:false}
          },
          emphasis : {
              color: 'rgba(0,0,0,0)'
          }
      };

      let options_mddfb = [];
      let mddfData = [];
      if(this.historyData.HistTaskOutTaskTunnel && this.historyData.HistTaskOutTaskTunnel.Rows) {
        if(this.DesCurTaskType == 2) {
          mddfData = this.historyData.HistTaskOutTaskTunnel.Rows;
        } else {
          mddfData = this.historyData.HistTaskDestination.Rows;
        }
      }

      this.mddfbList.forEach( function(l, li) {

          l.items.forEach( function(t, ti) {
            let count = 0;
            mddfData.forEach( function(m, mi) {
              if(t.number == m.DestinationNo) {
                if(l.taskType == self.DesCurTaskType) {
                  count = m.Count;
                }
              }
            });
            let mddfb_title = {
              text: count+'个',  //ratio+'%',
              x: 'center',
              y: 'center',
              itemGap: 20,
              textStyle : {
                color : "#0da89d",
                fontSize : 30,
                fontWeight : 'bolder'
              }
            }
            t.options = {
              title: mddfb_title,
              series : [
                {
                  type: 'pie',
                  clockWise: true,
                  radius: [50, 55],
                  itemStyle: dataStyle,
                  data:[
                    {
                      value: 100,
                      itemStyle: {
                        normal:{
                          color: "#68c8c1",
                        }
                      }
                    }
                  ]
                },
                /*{
                  type: 'pie',
                  clockWise: true,
                  radius : [71, 90],
                  itemStyle : dataStyle,
                  data:[
                    {
                      value: ratio,
                      itemStyle: {
                        normal:{
                          //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
                          color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                            {offset: 0, color: colors[di][0]}, {offset: 1, color: colors[di][1]}
                          ]),
                        }
                      }
                    },
                    {
                      value: 100-ratio,
                      name:'invisible',
                      itemStyle : placeHolderStyle
                    }
                  ]
                },*/
              ]
            };
          });

      });
      //this.options_mddfb = options_mddfb;
    },

    getTaskTab() {
      let self = this;
      this.taskListShowed = true;
      let taskType = this.taskTab[this.taskTabKey].tabs ? this.taskTab[this.taskTabKey].tabs[this.taskTabChildrenIndex].value : 0;
      this.$handleRequest(window.ApiHost1+'/api/DataStatistical/HistTask_Count', {
        "WareHouseCode": window.PYKWareHouseCode,
        "TaskNo": this.taskNumber,
        //"TaskCategory": this.taskTab[this.taskTabKey].cateid,
        "TaskType": taskType,
        "StartTime": this.date1,
        "EndTime": this.date2,
      }, 'post', function(res) {  //success


        let resData = res.retData;
        let allTaskTab = {};
        for(let key in self.taskTab) {
          self.taskTab[key].count = 0;
          let tabs = [];
          self.taskTypes.forEach( function(t, ti) {
            if(t.value > 0 && t.value < 4) {  //去掉全部
              tabs.push({label: t.label, value: t.value, count: 0});
            } else if(t.value == 4) {
              tabs.push({label: '其他任务', value: 4, count: 0});
            }
          });
          for(let kd in resData) {  //获取到的tab数据
            if(key == '全部任务') {
              self.taskTab[key].count += resData[kd].TotalCount;
            } else if(
              (key == '延时任务' && kd == 'DelayedCount') ||
              (key == '正常任务' && kd == 'UndelayCount')
            ) {
              self.taskTab[key].count = resData[kd].TotalCount;
              tabs.forEach( function(t, ti) {  //给子tab赋值count
                t.count = 0;
                resData[kd].Rows.forEach( function(l, li) {
                  if(l.TaskType == t.value) {
                    t.count = l.Count;
                    if(!allTaskTab[l.TaskType]) {
                      allTaskTab[l.TaskType] = 0;
                    }
                    allTaskTab[l.TaskType] += l.Count;
                  }
                });
              });
            }
            self.taskTab[key].tabs = tabs;
            if(self.taskTab['全部任务'].tabs) {
              self.taskTab['全部任务'].tabs.forEach( function(t, ti) {
                if(allTaskTab[t.value]) {
                  t.count = allTaskTab[t.value];
                }
              });
            }
          }
        }
        self.getTaskList();
      }, function(res) {
        //fail
      });
    },
    getTaskList() {
      let self = this;
      this.$handleRequest(window.ApiHost1+'/api/DataStatistical/HistTasks_Info', {
        "WareHouseCode": window.PYKWareHouseCode,
        "TaskNo": this.taskNumber,
        "TaskCategory": this.taskTab[this.taskTabKey].cateid,
        "TaskType": this.taskTab[this.taskTabKey].tabs[this.taskTabChildrenIndex].value,
        "StartTime": this.date1,
        "EndTime": this.date2,
        "PageIndex": this.pageIndex,
        "PageSize": this.pageSize,
      }, 'post', function(res) {  //success

 
        self.totalCount = res.retData.TotalCount;
        //let lists = self.$dataPage(res.retData.Rows, self.pageIndex, self.pageSize);
        let lists = res.retData.Rows;
        let tls = []
        let tmp = [];
        lists.forEach( function(l, li) {
          tmp.push(l);
          if((li+1) % 4 == 0) {
            tls.push(tmp);
            tmp = [];
          }
        });
        tls.push(tmp);
        self.taskList = tls;
      }, function(res) {
        //fail
      });
    },
    showDetail(item) {
      this.taskItem = item;
      this.taskListShowed = false;
      this.taskUnusualNodeIndex = 1;
      this.showNode(this.taskUnusualNodeIndex);
    },
    showNode(item) {
      let self = this;
      let nodeList = [];
      let len = 0;
      this.taskUnusualNodeIndex = item;
      if(this.taskItem && this.taskItem.DelayedTasks_Info) {
        len = this.taskItem.DelayedTasks_Info.length;
        this.taskItem.DelayedTasks_Info.forEach( function(d, di) {
          if(di == (self.taskUnusualNodeIndex * 2 - 1) || di == (self.taskUnusualNodeIndex * 2 - 2) ) {
            nodeList.push(d);
          }
        });
      }
      this.taskUnusualNode = nodeList;
      this.taskUnusualNodeCount = len;
    },
    watchTaskNumber() {  //实时监听input值
      console.log('watchTaskNumber', this.taskNumber)
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/components/xiayan/order/HistoryAnalyse.vue